import { Typography, useTheme } from "@mui/material";
import { useSelector } from 'react-redux';
import type { RootState, LobbyPlayer } from '../types/store';
import { Unplug } from 'lucide-react';

import UIIcon from './ui-icon';

type PlayerProps = {
    player: string;
};

export default function Player({player} : PlayerProps) {
    const theme = useTheme();
    const me = useSelector((state:RootState) => state.page.lobby.nickname);
    const players = useSelector((state:RootState) => state.page.lobby.players);
    const icons = useSelector((state:RootState) => state.settings.icons);
    
    let matchingPlayer = players.find((p:LobbyPlayer) => p.nickname.toLowerCase() === player.toLowerCase());
    
    if(matchingPlayer === undefined) {
        matchingPlayer = { nickname: player, icon: undefined, online: false };
    }
    

    let icon = icons[matchingPlayer.icon];
    
    return (
        <Typography 
            component="span"
            noWrap
            sx={{ fontSize: 'inherit', lineHeight: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 0.5, maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}
            color={me.toLowerCase() === matchingPlayer.nickname.toLowerCase() ? theme.palette.success.main : !matchingPlayer.online ? "#454444" : undefined}
        >
            {((icon && icon.icon) || !matchingPlayer.online) && <UIIcon icon={matchingPlayer.online ? icon.icon : Unplug} color={matchingPlayer.online ? icon.color : "#706d6d"} />} {matchingPlayer.nickname} 
        </Typography>
    );
}
